import React from "react";

function FaqAccordionsSection(props) 
{
    return (
        <section className="uk-section uk-section-default">
            <div className="uk-container">
                <h2 className="uk-heading-medium uk-text-center">Visa FAQ</h2>
                <ul uk-accordion="true" className="uk-margin-large-top">
                    {props.items.map(function(item, index) 
                    {
                        return (
                            <li key={index}>
                                <a className="uk-accordion-title" href="#">
                                    {item.question}
                                </a>
                                <div className="uk-accordion-content">
                                    <p>{item.answer}</p>
                                </div>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </section>
    );
}

export default FaqAccordionsSection;
